// extracted by mini-css-extract-plugin
export default {"square":"styles_square__8Z5A3","square_small":"styles_square_small__Oyb01"};